// extracted by mini-css-extract-plugin
export var fadeInOut = "_3v-3";
export var icon = "_3v-4";
export var savedIndicator = "_3v-2";
export var savingIndicator = "_3v-0";
export var spin = "_3v-1";